import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H5 } from "@/components/standard/BFText"
import { View } from "react-native"
import { BFCloseButton } from "@/components/standard/BFCloseButton"
import { persistentAtom } from "@nanostores/persistent"
import { Image } from "expo-image"
import useDeviceAttributes from "@/hooks/useDeviceAttributes"
import { PlayStoreDownloadButton } from "@/components/buttons/PlayStoreDownloadButton"
import { AppleStoreDownloadButton } from "@/components/buttons/AppleStoreDownloadButton"
import { useStore } from "@nanostores/react"
import { loanDashboardAppInstallClicked } from "@/analytics/events/loans"

export const $downloadAppWidget = persistentAtom<"true" | "false">(
  "downloadAppWidget",
  "true"
)

export const DownloanAppWidget = () => {
  const { isIos, isAndroid } = useDeviceAttributes()
  const shouldShow = useStore($downloadAppWidget)

  if (isIos || isAndroid || shouldShow === "false") {
    return null
  }

  return (
    <Vertical
      className={"border border-light-grey rounded-md pt-6 relative bg-white"}
    >
      <Horizontal className={"justify-between w-full px-5"}>
        <Vertical className={"flex-1 pb-6 gap-1"}>
          <H5 color={"primary"}>{"Keep tracking your loan's progress:"}</H5>
          <H5 color={"primaryLight"}>Download the Backflip App</H5>
        </Vertical>
        {/* <View className={"px-4 justify-center items-center"}> */}
        <Image
          source={require("@/assets/images/ios-icon.png")}
          style={{
            marginHorizontal: 16,
            width: 48,
            height: 48,
            borderRadius: 8,
          }}
        />
        {/* </View> */}
      </Horizontal>
      <View className="absolute top-3 right-3 size-4">
        <BFCloseButton
          dark={true}
          onPress={() => {
            $downloadAppWidget.set("false")
          }}
        />
      </View>
      <Horizontal
        className={"px-4 py-3  bg-grey gap-3 items-center justify-center"}
      >
        <PlayStoreDownloadButton
          className={"mt-[-13px]"}
          width={121}
          height={36}
          onPress={() => {
            loanDashboardAppInstallClicked({
              badgeType: "google_install_badge",
            })
          }}
        />
        <AppleStoreDownloadButton
          width={121}
          height={36}
          onPress={() => {
            loanDashboardAppInstallClicked({
              badgeType: "apple_install_badge",
            })
          }}
        />
      </Horizontal>
    </Vertical>
  )
}
